define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi",
	"csi/_base/underscore",
	"csi/def/Action",
	"csi/def/Relationship",
	"csi/def/ViewRef",
	"csi/form/Widget",
	"csi/locale",
	"csi/reflection",
	"csi/store/_base",
	"csi/store/Names",
	"csi/xml",
	"csi/xml/Query",
	"./util"
], function(declare,lang,csi,_,Action,Relationship,ViewRef,Widget,locale,reflection,csiStore,Names,xml,Query, util) {

	var DEFINITION = "Definition";
	return declare(Widget, {

		_buildView: function() {
			var ctx = this.getContext();
			var section = ctx.getNode();
			if (util.isSectionAdHoc(ctx, section)) {
				_.each(this.defView.m_fields, function(field) {
					field.bForceEditable = true;
				}, this);

				// set initial value to prevent the value of the field to setting "Go to Dialog"
				var fd = this.defView.getFormData();
				fd.setFieldInitialValue(DEFINITION, csi.EMPTY_URL);
			}

			this.inherited(arguments);
		},

		getFieldStore: function(/*Field*/field, /*String*/value) {
			if (field.getControlName() === DEFINITION) {
				var ctx = this.getContext();
				var subtypeUrl = ctx.cache.getNode( ctx.getNode().Definition).Subtype; //retrieve subtype from SpecificationSectionDefinition
				var query = new Query()
							.RefAttr(reflection.ATTR_SUBTYPE, xml.OP_EQUALS, subtypeUrl)
							.Attr("Active", xml.OP_EQUALS, true)
							.Attr("Special", xml.OP_EQUALS, false);

				// create relationship for Definition dropdown
				var rel = lang.mixin(new Relationship(), {
					m_typeNode: "SpecificationSectionDefinition",
					m_query: query // filter by the subtype  and special
				});

				var store = ctx.view.createHeadingNamesStore(ctx, field, null, rel);

				// create view for goto dialog
				store.action = lang.mixin(new Action(),{
					m_viewRef: lang.mixin(new ViewRef(), {
						m_id: "SpecificationSectionDefinitions",
						m_url: "centric://REFLECTION/INSTANCE/_CS_Data/null"
					}),
					m_fixedQuery: query // filter by the subtype
				});
				return store;
			} else {
				return this.inherited(arguments);
			}
		}
	});

});